import { RootState } from '../reducer';
import { createSelector } from 'reselect';

export const routerStateSelector = (state: RootState) => state.router;

export const selectSurveyUuid = createSelector(
  routerStateSelector, (routerState) => routerState.location?.pathname?.substring(1),
);
